import React, { useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Icons } from '../../Icons/Icons';
import { SimpleTextViewModel } from '../../../../../ViewModel';

interface TextEntryProps {
    simpleText: SimpleTextViewModel;
    autofocus?: boolean;
    className?: string;
    allowEmptyDelete?: boolean;
    onEnterPressed?: () => void;
    onAdd?: () => void;
    onDelete?: () => void;
    onChanged?: () => void;
    onLosingFocus?: () => void;
    shouldCaptureFocus?: boolean;
}

export const TextEntry: React.FC<TextEntryProps> = ({
    className,
    simpleText,
    autofocus,
    onAdd,
    onDelete,
    onChanged,
    allowEmptyDelete,
    onEnterPressed,
    shouldCaptureFocus,
    onLosingFocus }) => {

    if (simpleText === undefined) {
        console.warn('TextEntry: simpleText is undefined');
        return <></>;
    } else if (simpleText.TypedData === undefined) {
        console.warn('TextEntry: simpleText.TypedData is undefined');
        return <></>;
    }

    const [text, setText] = React.useState(simpleText.TypedData.text);
    const [hasFocus, setHasFocus] = React.useState(false);
    const inputRef = React.useRef<HTMLInputElement>(null);

    var timeoutId: ReturnType<typeof setTimeout> | undefined;
    const onBlur = () => {
        if (timeoutId)
            clearTimeout(timeoutId);
        timeoutId = setTimeout(() => setHasFocus(false), 100);

        if (text === '') {
            onDelete && onDelete();
        }
    }



    const showAddButton = hasFocus && text !== '' ? ' gl-has-focus' : '';
    const hasFocusClassName = hasFocus ? ' gl-has-focus' : '';

    const showRemoveButton = allowEmptyDelete === true ? hasFocusClassName : showAddButton;

    const onTextChanged: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        simpleText.TypedData.text = e.target.value
        setText(simpleText.TypedData.text);
        onChanged && onChanged();
    }

    const onKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (e.key === 'Enter') {
            onEnterPressed && onEnterPressed();
        } else if (e.key === 'Tab') {
            e.preventDefault();
            onLosingFocus && onLosingFocus();
        } else if (e.key === 'Backspace' && text === '') {
            onDelete && onDelete();
            e.preventDefault();
        }
    }

    useEffect(() => {
        if (shouldCaptureFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [shouldCaptureFocus]);

    return (
        <div className="gl-text-entry">
            <InputText
                autoFocus={autofocus}
                className={'gl-input-field gl-text-entry-typography ' + (className ?? '') + hasFocusClassName}
                placeholder=""
                value={text} onChange={onTextChanged}
                onFocus={() => setHasFocus(true)}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                ref={inputRef}
            />
            <div className="gl-button-wrapper">
                <button
                    className={'gl-add-text-button' + showAddButton}
                    onClick={() => {
                        if (onAdd)
                            onAdd();
                    }}>
                    <Icons.AddTextIcon className='gl-add-icon' />
                </button>

                <button
                    className={'gl-remove-text-button' + showRemoveButton}
                    onClick={() => {
                        if (onDelete)
                            onDelete();
                    }}>
                    <Icons.RemoveTextIcon className='gl-remove-icon' />
                </button>
            </div>

        </div>
    );
};